import { Container } from '@repo/ui/container';

import { Assets } from '@/components/assets';
import { FiltersContainer } from '@/components/filters';

export const AssetsList = () => {
    return (
        <Container testId="assets-list-view">
            <FiltersContainer />
            <Assets />
        </Container>
    );
};
